/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Whether the email was sent or received
 * @export
 */
export const EmailDirection = {
    Outbound: 'outbound',
    Inbound: 'inbound'
} as const;
export type EmailDirection = typeof EmailDirection[keyof typeof EmailDirection];


export function instanceOfEmailDirection(value: any): boolean {
    for (const key in EmailDirection) {
        if (Object.prototype.hasOwnProperty.call(EmailDirection, key)) {
            if (EmailDirection[key as keyof typeof EmailDirection] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EmailDirectionFromJSON(json: any): EmailDirection {
    return EmailDirectionFromJSONTyped(json, false);
}

export function EmailDirectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailDirection {
    return json as EmailDirection;
}

export function EmailDirectionToJSON(value?: EmailDirection | null): any {
    return value as any;
}

export function EmailDirectionToJSONTyped(value: any, ignoreDiscriminator: boolean): EmailDirection {
    return value as EmailDirection;
}

